import { Component } from '@angular/core'
import { Router } from '@angular/router'

import { UsersService } from '@innersight-os/shared/firebase-services'
import { tap } from 'rxjs/operators'

@Component({
    selector: 'is-auth',
    templateUrl: './auth.component.html',
    styles: [],
    standalone: false
})
export class AuthComponent {
  myOnboardingStage$ = this.users.myOnboardingStage$.pipe(
    tap(stage => {
      if(stage === 'onboarded') this.router.navigate(['/operations'])
    })
  )

  constructor(
    private router: Router,
    public users: UsersService,
  ) {}
}
